import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import aaraclouds from "../../Assets/aaraclouds.png";

export default function Whatsaap() {

  return (
      <FloatingWhatsApp 
       phoneNumber="8881810181"
        accountName="Aara Cloud"
        avatar={aaraclouds}
        allowClickAway
        notification
        notificationSound />
  )
}